import List from 'src/storage/list';
import constants from 'src/constants';
import AlertManager from '../alert/AlertManager';
import {
  getUnavailableStateForNow,
  hasSameId,
  lang,
  upperFirstCharAll,
  userFullName
} from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

class ContactModel extends List {
  id = 'Contacts';
  refreshOnInit = true;
  refreshOnSubscribe = false;
  persistent = false;
  idKey = 'partnerId';
  sortBy = {
    key: 'posted',
    desc: true
  };
  searchListLimit = 33;
  defaultState = () => ({
    active: '',
    archive: false,
    archiveExpanded: false,
    archiveUnreadCounter: 0,
    current: 'recent',
    tabs: {
      main_treatment: 'treatment',
      main_message: 'chat'
    },
    isOpenBookAppointment: false,
    images: [],
    hideInfo: true,
    hasMoreSearch: {
      contacts: true,
      doctors: true,
      users: true
    }
  });
  apiConfig = {
    refresh: {
      url: 'contact/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'contact_refresh'
    },
    list: {
      url: 'contact/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'contact/search',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'onSearchFinish'
    },
    loadMoreSearchContacts: 'contact/search',
    loadMoreSearchDoctors: 'contact/search',
    loadMoreSearchUsers: 'contact/search',
    markRead: {
      url: 'contact/markRead',
      validation: {
        partnerId: 'userId',
        lastNumber: 'number'
      },
      cancellable: false
    },
    findById: {
      url: 'doctor/detail',
      validation: {
        // id: 'number'
      },
      cancellable: true
    },
    getPatientInfo: {
      url: 'patient/info',
      validation: {
        id: 'userId'
      },
      cancellable: false
    },
    setArchive: {
      url: 'contact/setArchive',
      validation: {
        partnerId: 'userId'
      },
      cancellable: false
    },
    getArchiveCounter: {
      url: 'contact/getArchiveCounter',
      validation: {},
      cancellable: true
    },
    remove: {
      url: 'contact/remove',
      validation: {
        partnerId: 'userId',
        forBoth: 'boolean'
      },
      cancellable: false
    },
    updateFreeChatEnabled: {
      url: 'profile/update/freeChatEnabled',
      validation: {
        target: 'baseId',
        active: 'boolean'
      },
      cancellable: true
    }
  };
  _events = {
    openDoctorMessages: 'onOpenDoctorMessages',
    profile: 'handleChangeProfileAndSwitchAccount',
    openContact: 'onOpenContact',
    closeContact: 'handleClose',
    'foxsocket:message:msg': 'onMessage',
    updateContact: 'handleUpdateContact',
    'foxsocket:message:contact_update': 'handleUpdateContactWS',
    'foxsocket:message:contact_blocked_create': 'contactBlockCreated',
    'foxsocket:message:contact_blocked_remove': 'contactBlockRemoved',
    changeMessageTab: 'changeMessageTab',
    onSearchFinish: 'onSearchFinish'
  };

  listParams(loadMore) {
    let req = {
      skip: 0,
      limit: this.listLimit,
      archive: !!this.state.archive
    };
    let query = this.input('search') || this.listInput('search');
    if (query.length > 0) {
      req.query = query;
      req.limit = this.searchListLimit;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  onHandleChangeProfile = (profile) => {
    this.setState({ profile });
  };

  handleRemove = ({ partnerId, forBoth }) => {
    let contact = this.items('recent').find((item) => item.partnerId == partnerId);
    this.removeItem(contact.id, { listId: 'recent' });
    this.removeItem(contact.id, { listId: 'archive' });
    this.handleClose();
    this.emit('closeContact', { partnerId });
    this.api('remove', { partnerId, forBoth }, (err, res, success) => {
      if (!success) {
        this.addItem(contact, { listId: 'recent' });
      }
    });
  };

  changeMessageTab(tab) {
    model.changeTab('main_message', tab.id);
  }

  // open messages from doctor profile page
  onOpenDoctorMessages = (doctor) => {
    this.emit('openContact', {
      contact: {
        ...doctor,
        partnerId: doctor.id
      }
    });
    this.openId(doctor.id);
  };

  openId = (partnerId) => {
    this.log('openId', partnerId);
    this.setRouteActivePartner(partnerId);
    if (partnerId && hasSameId(this.state.active, partnerId)) {
      this.emit('contactOpened', this.state);
      if (this.state.contact?.messages) {
        this.markRead(this.state.active, this.state.contact?.messages);
      }
      return this.log('same partnerId, ignore');
    }
    if (!partnerId) {
      this.log('openId !partnerId, closing');
      this.emit('closeContact', {});
      return;
    }

    let contact = this.items('recent').find(
      (item) =>
        hasSameId(item.partnerId, partnerId) ||
        item.partnerProfile?.username == partnerId ||
        item.username == partnerId ||
        hasSameId(item.id, partnerId)
    );
    if (!contact) {
      contact = this.items('search').find(
        (item) =>
          hasSameId(item.partnerId, partnerId) ||
          item.partnerProfile?.username == partnerId ||
          item.username == partnerId ||
          hasSameId(item.id, partnerId)
      );
    }
    if (contact) {
      this.setRouteActivePartner(contact.partnerId || contact.id, contact);
      if (this.state.active === contact.id) {
        return this.log('same partnerId, ignore');
      } else {
        this.emit('openContact', { contact });
      }
      this.showUnavailableDoctor(contact?.id);
      this.showDisabledDoctorNotice(contact?.id);
    } else {
      this.api('findById', { id: partnerId }, (err, res, success) => {
        if (success) {
          contact = res;
          if (!contact.partnerId) contact.partnerId = contact.id;
          this.setRouteActivePartner(contact.partnerId || contact.id, contact);
          if (this.state.active === contact.id) {
            return this.log('same partnerId, ignore');
          } else {
            this.emit('openContact', { contact });
          }
          this.showUnavailableDoctor(contact.id);
          this.showDisabledDoctorNotice(contact.id);
        }
      });
    }
  };

  showUnavailableDoctor = (partnerId) => {
    let contact = this.items('recent').find((item) => item.partnerId === partnerId);
    if (!contact) {
      contact = this.items('search').find((item) => item.partnerId === partnerId);
    }

    const nowState = getUnavailableStateForNow(contact?.accountState);

    try {
      if (contact && contact?.isDoctor && model.state.user?.isPatient && !!nowState) {
        setTimeout(() => {
          AlertManager.popup(AlertManager.TYPES.WARN, {
            maxWidth: 450,
            close: false,
            title: lang.t(
              nowState?.end
                ? LANG_CONST.notice.not_available_doctor_end_date
                : LANG_CONST.notice.not_available_doctor,
              {
                doctor: upperFirstCharAll(userFullName(contact)),
                endDate: nowState?.end && nowState?.end.format('DD MMMM YYYY')
              }
            ),
            actionButton: {
              label: LANG_CONST.buttons.ok,
              action: (props) => props.hide()
            }
          });
        }, 100);
      }
    } catch (e) {
      console.log('showAvailableDoctor error', e);
    }
  };

  showDisabledDoctorNotice = (partnerId) => {
    let contact = this.items('recent').find((item) => item.partnerId === partnerId);
    if (!contact) {
      contact = this.items('search').find((item) => item.partnerId === partnerId);
    }

    try {
      if (
        contact &&
        contact.isDoctor &&
        model.state.user?.isPatient &&
        contact.status === constants.general.userStatus.disabled
      ) {
        setTimeout(() => {
          const clinicName =
            contact.clinicName ||
            (contact.partnerClinicProfile?.firstName && userFullName(contact.partnerClinicProfile));

          AlertManager.popup(AlertManager.TYPES.INFO, {
            maxWidth: 450,
            close: false,
            title: lang.t(
              contact.isDoctor && !!clinicName
                ? LANG_CONST.notice.disabled_clinic_doctor
                : LANG_CONST.notice.disabled_doctor,
              {
                doctor: upperFirstCharAll(userFullName(contact))
              }
            ),
            actionButton: {
              label: LANG_CONST.buttons.ok,
              action: (props) => props.hide()
            }
          });
        }, 100);
      }
    } catch (e) {
      console.log('checkDisabledDoctor error', e);
    }
  };

  onOpenContact = async ({ contact }) => {
    this.log('onOpenContact', contact);
    let partnerId = contact.partnerId || contact.id;
    this.setRouteActivePartner(partnerId, contact);
    let userId = this.userId;
    let listId = this.state.current;
    let items = this.items(listId);
    var wasUnread = 0;
    let exist = false;
    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.partnerId === partnerId) {
        exist = true;
        contact = item;
        wasUnread = this.getItemUnread(item, userId);
        this.markItemRead(item, userId);
        break;
      }
    }
    if (!contact.isDoctor && this.isLogged) {
      contact.partnerProfile = await this.getPatientInfo(contact.id);
    }
    if (!exist) {
      if (!contact.users) {
        contact.users = [
          { _id: this.userId, unread: 0 },
          { _id: partnerId, unread: 0 }
        ];
      }
      this.addItem(contact, { listId });
    }
    this.setState({ active: partnerId, contact, contactUser: contact });
    if (wasUnread) {
      this.log('wasUnread', contact.messages, contact.archive);
      if (contact.messages) {
        this.markRead(partnerId, contact.messages);
        if ((contact.archive || listId == 'archive') && this.state.archiveUnreadCounter > 0) {
          this.setState({ archiveUnreadCounter: this.state.archiveUnreadCounter - 1 });
        }
      }
      this.setListState({ items }, listId, null, true);
      this.triggerDelay();
    }
    setTimeout(() => {
      this.emit('contactOpened', contact);
    }, 0);
  };

  isActive = (userId) => {
    return this.state.active === userId;
  };

  getContactIdentifiers = (contact, partnerId) => {
    return [
      partnerId,
      contact?.id,
      contact?.partnerId,
      contact?.username,
      contact?.partnerUsername,
      contact?.partnerProfile?.id,
      contact?.partnerProfile?.username
    ].filter(
      (id, index, list) =>
        id !== null &&
        id !== undefined &&
        id !== '' &&
        list.findIndex((otherId) => hasSameId(otherId, id)) === index
    );
  };

  setRouteActivePartner = (partnerId, contact = null) => {
    this.routeActivePartnerId = partnerId || null;
    this.emit('activeMessageContact', {
      partnerId: this.routeActivePartnerId,
      ids: this.getContactIdentifiers(contact, this.routeActivePartnerId)
    });
  };

  isRouteActive = (userId) => {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    const onMessagesRoute = /^\/(admin\/)?messages(\/|$)/.test(pathname);

    if (onMessagesRoute && hasSameId(this.routeActivePartnerId, userId)) return true;
    if (this.isActive(userId)) return this.state.isFocus || onMessagesRoute;
    if (!onMessagesRoute) return false;

    const contact = this.state.contact || {};
    return [contact.id, contact.partnerId, contact.partnerProfile?.id].some((id) =>
      hasSameId(id, userId)
    );
  };

  handleClose = () => {
    this.log('handleClose');
    this.setRouteActivePartner(null);
    this.setState({ active: null, contact: null, contactUser: null });
  };

  open = (contact) => {
    let id = contact.partnerId;
    let prevId = this.state.active;

    if (id === prevId) {
      this.emit('closeContact');
    } else {
      this.emit('openContact', { contact, prevContact: prevId, changed: true });
    }
  };

  mapItem = (item) => {
    if (!item.partnerAvatarUrls) {
      const user = { id: item.partnerId, gender: item.partnerGender };
      item.partnerAvatarUrls = this.makeUserAvatar(user, item.partnerAvatar, this.imageSizes.user);
    }
    item.unread = this.getItemUnread(item);
    if (this.isRouteActive(item.partnerId || item.id)) {
      this.markItemRead(item);
    }
    return item;
  };

  getItemUnread = (item, userId = this.userId) => {
    const userItems = (item.users || []).filter((user) => user._id === userId);
    if (userItems.length > 0) {
      return userItems.reduce((total, user) => total + (user.unread || 0), 0);
    }
    return item.unread || 0;
  };

  markItemRead = (item, userId = this.userId) => {
    item.unread = 0;
    (item.users || []).forEach((user) => {
      if (user._id === userId) user.unread = 0;
    });
  };

  markRead = (partnerId, lastNumber) => {
    this.log('markRead', { partnerId, lastNumber });
    this.api('markRead', { partnerId, lastNumber }, null, true, true);
  };

  onMessage = ({ channel, data }) => {
    let { active } = this.state;
    let userId = this.userId;
    if (channel !== 'u-' + userId) return;
    let { from, to, archive, wasUnread } = data;
    let own = from === userId;
    let partnerId = own ? to : from;

    let isActive = active === partnerId;
    let isRouteActive = this.isRouteActive(partnerId);

    this.log('onMessage', { partnerId, archive, isActive });

    let exist = false;
    ['recent', 'archive'].forEach((listId) => {
      let items = this.items(listId);
      let item = items.find((item) => item.partnerId === partnerId || item.id === partnerId);
      if (!item) {
        if (this.getState().current !== 'search') {
          if (!this.getApiState('refresh').loading)
            setTimeout(this.refresh.bind(this, archive ? 'archive' : 'recent'), 0);
        } else {
          this.refreshApiIdAfterSearchClose = archive ? 'archive' : 'recent';
        }
        return;
      }
      exist = listId;
      item.lastMessage = data.text;
      item.posted = data.date;

      if (own || isRouteActive) {
        this.markItemRead(item, userId);
      } else {
        let usersIndex = item.users[0]._id === userId ? 0 : 1;
        if (archive && !wasUnread && listId == 'archive' && item.unread == 0) {
          this.setStateSilent({ archiveUnreadCounter: this.state.archiveUnreadCounter + 1 });
        }
        item.unread += 1;
        item.users[usersIndex].unread += 1;
      }
      item.messages += 1;
      if (!own && isRouteActive && data.counter) {
        this.markRead(partnerId, data.counter);
      }
      this.setListState({ items: this.sort(items, this.sortBy) }, listId, null, true);
      this.triggerDelay();
    });
    if (!exist) {
      if (!own && archive && !wasUnread) {
        this.setStateSilent({ archiveUnreadCounter: this.state.archiveUnreadCounter + 1 });
      }

      let loading = this.getApiState('refresh').loading;
      let current = this.state.current;
      if (!loading && ((archive && current === 'archive') || (!archive && current === 'recent'))) {
        this.log('onMessage contact not exist, refreshing', { partnerId, archive, current });
        setTimeout(() => {
          this.refresh(archive ? 'archive' : 'recent');
        }, 0);
      } else {
        this.log('onMessage contact not exist, refreshing in progress', { partnerId });
      }
    } else {
      this.log('onMessage contact exist', partnerId, exist);
    }
  };

  handleUpdateContactWS = ({ data }) => {
    this.handleUpdateContact({
      partnerId: data.partnerId,
      data: data
    });
  };

  handleUpdateContact = ({ partnerId, data }) => {
    let mapItem = (item) => {
      if (item.partnerId === partnerId) {
        Object.keys(data).map((key) => {
          if (key !== 'key' && key !== 'value') {
            if (['status', 'accountState'].includes(data.key)) {
              item[data.key] = data.value;
            } else if (['unread', 'lastRead'].includes(key)) {
              const auth = this.state.user;
              item.users = (item.users || []).map((u) => {
                if (u._id === auth?.id) {
                  u[key] = data[key];
                }
                return u;
              });
            } else item[key] = data[key];
            if (key === 'partnerAvatar' || key === 'partnerId' || key === 'partnerGender') {
              item.partnerAvatarUrls = this.makeUserAvatar(
                { id: item.partnerId, gender: item.partnerGender },
                item.partnerAvatar,
                this.imageSizes.user
              );
            }
          }
        });
        this.log('handleUpdateContact updated');
      }
      return item;
    };
    let filterItem = (item) => !item.removed;
    this.setListState({ items: this.items('recent').map(mapItem).filter(filterItem) }, 'recent');
    this.setListState({ items: this.items('archive').map(mapItem).filter(filterItem) }, 'archive');
    this.items('search').map(mapItem);
    if (data && typeof data.archive != 'undefined') this.filterArchive({ partnerId, data });
    if (partnerId === this.state.active && data.removed) this.emit('closeContact', { partnerId });
    this.trigger();
    this.save();
  };

  filterArchive = () => {
    function filterItem(archiveVisible, item) {
      return (item.archive && archiveVisible) || (!item.archive && !archiveVisible);
    }
    let recentItems = this.items('recent').filter(filterItem.bind(this, false));
    let archiveItems = this.items('archive').filter(filterItem.bind(this, true));
    let searchItems = this.items('search').filter(filterItem.bind(this, !!this.state.archive));
    this.setListState({ items: recentItems }, 'recent');
    this.setListState({ items: archiveItems }, 'archive');
    this.setListState({ items: searchItems }, 'search');
  };

  contactBlockCreated = ({ data }) => {
    if (data.userId !== this.user.id) {
      return;
    }

    this.items('recent').map((t) => {
      if (t.partnerId === data.blockedId) {
        t.blocked = data.created;
      }
    });
    this.items('search').map((t) => {
      if (t.partnerId === data.blockedId) {
        t.blocked = data.created;
      }
    });
    this.log('handleUpdateContact updated');
    this.trigger();
    this.save();
  };

  contactBlockRemoved = ({ data }) => {
    if (data.userId !== this.user.id) {
      return;
    }

    this.items('recent').map((t) => {
      if (t.partnerId === data.blockedId) {
        delete t.blocked;
      }
    });
    this.items('search').map((t) => {
      if (t.partnerId === data.blockedId) {
        delete t.blocked;
      }
    });
    this.log('handleUpdateContact updated');
    this.trigger();
    this.save();
  };

  getPatientInfo = (id) => {
    return new Promise((resolve, reject) => {
      this.api('getPatientInfo', { id }, (err, res, success) => {
        if (success) {
          resolve(res);
        } else {
          reject(null);
        }
      });
    });
  };

  setArchive = (partnerId, value) => {
    this.handleUpdateContact({ partnerId, data: { archive: value } });
    this.api('setArchive', { partnerId, value }, (err, res, success) => {
      if (!success) {
        this.handleUpdateContact({ partnerId, data: { archive: !value } });
      }
    });
  };

  loadArchiveCounter = () => {
    this.api('getArchiveCounter', {}, (err, res, success) => {
      if (success) {
        this.setState({ archiveUnreadCounter: res });
      }
    });
  };

  handleChangeSearch2 = (text) => {
    this.cancelApi('loadMoreSearchContacts');
    this.cancelApi('loadMoreSearchDoctors');
    this.cancelApi('loadMoreSearchUsers');

    if (!text && !!this.refreshApiIdAfterSearchClose) {
      setTimeout(() => {
        this.refreshApiIdAfterSearchClose = null;
        this.refresh(this.refreshApiIdAfterSearchClose);
      }, 10);
    }
    return this.handleChangeSearch(text);
  };

  onSearchFinish = (items) => {
    let hasMoreSearch = this.state.hasMoreSearch;
    ['contacts', 'doctors', 'users'].forEach((group) => {
      let groupItems = items.filter((item) => item.group == group);
      hasMoreSearch[group] = groupItems.length >= Math.floor(this.searchListLimit / 3);
    });
    this.setState({ hasMoreSearch });
  };

  loadMoreSearch = (group) => {
    let skip = this.items().filter((item) => item.group == group).length;
    let limit = this.searchListLimit * 3;
    let apiId =
      group == 'contacts'
        ? 'loadMoreSearchContacts'
        : group == 'doctors'
          ? 'loadMoreSearchDoctors'
          : 'loadMoreSearchUsers';
    this.api(
      apiId,
      { group, query: this.listInput('search'), skip, limit },
      (err, res, success) => {
        if (success) {
          let hasMoreSearch = this.state.hasMoreSearch;
          if (res.length < limit) hasMoreSearch[group] = false;
          this.setState({ hasMoreSearch });

          let items = this.items();
          let insertIndex = items.length;
          items.forEach((item, index) => {
            let nextItem = index + 1 < items.length ? items[index + 1] : {};
            if (item.group == group && nextItem.group != group) insertIndex = index + 1;
          });
          for (let i = 0; i < res.length; i++) {
            items.splice(insertIndex + i, 0, res[i]);
          }
        }
      }
    );
  };

  handleFreeChatEnabled = (target, active, cb) => {
    this.api('updateFreeChatEnabled', { target, active }, cb);
  };
}

const model = new ContactModel();
export default model;
